<!-- eslint-disable -->
<template lang="pug">
    div(v-if="errorStatus === 403")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    profile-preview(v-else-if="!isLoading && viewedUser && user", :is-user-preview="true")
        template(slot="left")
            img.profile__avatar(:src="viewedUser.avatar")
            .profile__name
                | {{ viewedUser.fullName }}
            .profile__items
                .profile__box
                    .profile__send-message-container
                        cs-button.profile__send-message(
                            color="white",
                            :full-width="true",
                            @click="switchModal('message')"
                        )
                            | {{ $i18n.t('profiles.profiles_user_sendMessage') }}
                    .profile__item.profile__item--size
                        svg-icon.profile__icon.profile__icon--small(
                            v-if="viewedUser.status === 'active'",
                            name="check",
                            height="18px",
                            width="14px"
                        )
                        svg-icon.profile__icon.profile__icon--small(
                            v-else
                            name="times"
                            size="small"
                        )
                        .profile__info
                            .info__header {{ $i18n.t('profiles.profiles_profile_status') }}
                            .info__body {{ statusString }}
                    .profile__item.profile__item--size(v-if="!viewedUser.isManagerOrSupport")
                        svg-icon.profile__icon(name="gift", size="large")
                        .profile__info
                            .info__header {{ $i18n.t('profiles.profiles_user_birthDate') }}
                            .info__body {{ viewedUser.birthday | moment('DD.MM.YYYY')}}
                    .profile__item.profile__item--size(v-if="viewedUser.sex")
                        svg-icon.profile__icon(:name="viewedUser.sex", size="large")
                        .profile__info
                            .info__header {{ $i18n.t('profiles.profiles_user_gender') }}
                            .info__body {{ $i18n.t('profiles.profiles_user_' + viewedUser.sex) }}
                    .profile__item.profile__item--size(:title="viewedUser.username")
                        svg-icon.profile__icon(name="login", size="large")
                        .profile__info
                            .info__header {{ $i18n.t('profiles.profiles_user_login') }}
                            .info__body {{ viewedUser.username }}
                    .profile__item.profile__item--size(v-if="viewedUser.type === 'student'")
                        svg-icon.profile__icon(name="goal", size="large")
                        .profile__info
                            .info__header {{ $i18n.t('profiles.profiles_user_progress') }}
                            .info__body {{ averageProgress }}
                template(v-if="arePointsAllowed")
                    divider(:margin="'30px auto 0'" :not-show-last-child="true")
                    .profile__box
                        .profile__item.profile__item--size(v-if="$isMapAvailable && courseAllowMap")
                            svg-icon.profile__icon(name="plane", size="large")
                            .profile__info
                                .info__header {{ $i18n.t('profiles.profiles_user_miles') }}
                                .info__body
                                    span {{ viewedUser.miles }}
                                    span &nbsp;
                                    span(v-if="($scoring && user.type !== 'student' && user.type !== 'olympiads-student') || (user.isSuperadmin || user.isManagerOrSupport)")
                                        a.profile__link(
                                            href="javascript://"
                                            @click="switchModal('miles')"
                                            :title="$i18n.t('profiles.profiles_user_buttonChange')"
                                        )
                                            | {{ $i18n.t('profiles.profiles_user_buttonChange') }}
                                router-link.profile__link(
                                    :to="routeObject('miles')"
                                    class="is-info"
                                    :title="$i18n.t('profiles.profiles_user_changeHistoryTitle')"
                                ) {{ $i18n.t('profiles.profiles_user_changeHistory') }}
                        .profile__item.profile__item--size(v-if="$isDetectiveAvailable && courseAllowDetective")
                            svg-icon.profile__icon(name="explore", size="large")
                            .profile__info
                                .info__header {{ $i18n.t('points.points_detectiveTable_points') }}
                                .info__body
                                    span {{ viewedUser.detectivePoints }}
                                    span &nbsp;
                                    span(v-if="($scoring && user.type !== 'student' && user.type !== 'olympiads-student') || (user.isSuperadmin || user.isManagerOrSupport)")
                                        a.profile__link(
                                            href="javascript://"
                                            @click="switchModal('detective-points')"
                                            :title="$i18n.t('profiles.profiles_user_buttonChange')"
                                        )
                                            | {{ $i18n.t('profiles.profiles_user_buttonChange') }}
                                router-link.profile__link(
                                    :to="routeObject('detective')"
                                    :title="$i18n.t('profiles.profiles_user_changeHistoryTitle')"
                                ) {{ $i18n.t('profiles.profiles_user_changeHistory') }}
                        template(v-if="$pointsSystem")
                            .profile__item.profile__item--size(v-for="access in viewedUser.pointsAccesses")
                                svg-icon.profile__icon(name="coin", size="large")
                                .profile__info
                                    .info__header {{ $i18n.t('common.common_points_' + access) }}
                                    .info__body
                                        span {{ pointsForAccess(access) }}
                                        span &nbsp;
                                        span(v-if="($scoring && user.type !== 'student' && user.type !== 'olympiads-student') || (user.isSuperadmin || user.isManagerOrSupport)")
                                            a.profile__link(
                                                href="javascript://"
                                                @click="switchModal('points', access)"
                                                :title="$i18n.t('profiles.profiles_user_buttonChange')"
                                            )
                                                | {{ $i18n.t('profiles.profiles_user_buttonChange') }}
                                    router-link.profile__link(
                                        :to="routeObject('points', access)"
                                        class="is-info"
                                        :title="$i18n.t('profiles.profiles_user_changeHistoryTitle')"
                                    ) {{ $i18n.t('profiles.profiles_user_changeHistory') }}
        template(slot="right" )
            .info__buttons(v-if="isButtonsAvailable")
                template(v-if="canEditProfile")
                    cs-button.info__button(
                        v-if="viewedUser.status === 'active'"
                        @click="$router.push({name: 'user:edit', params: {id: viewedUser.id, type: viewedUser.type}})"
                        color="green"
                    )
                        | {{ $i18n.t('profiles.profiles_profile_edit') }}
                    cs-button.info__button(
                        v-if="viewedUser.status === 'active' && !viewedUser.isManagerOrSupport && !isMyProfile"
                        @click="archiveUser()"
                        color="green"
                    )
                        | {{ $i18n.t('list.list_common_actionsArchive') }}
                    cs-button.info__button(
                        v-if="!(viewedUser.status === 'active') && !viewedUser.isManagerOrSupport"
                        @click="checkRestorePrice()"
                        color="green"
                    )
                        | {{ $i18n.t('profiles.profiles_profile_restore') }}
                cs-button.info__button(
                    v-if="canAuthInProfile"
                    @click="authentication(id)"
                    color="blue"
                )
                    | {{ $i18n.t('profiles.profiles_profile_auth') }}
            .info__item
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_user_contacts') }}
                divider(:margin="'25px auto 0'" :not-show-last-child="true")
                .row.contacts
                    .col-xs-12.col-md-6.contacts__item(v-if="!viewedUser.isManagerOrSupport")
                        .contacts__item-header {{ $i18n.t('profiles.profiles_profile_phone') }}
                        template(v-if="showContactInfo && viewedUser.phone") {{ viewedUser.phone }}
                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
                    .col-xs-12.col-md-6.contacts__item(v-if="!viewedUser.isManagerOrSupport")
                        .contacts__item-header {{ $i18n.t('profiles.profiles_grade_location') }}:
                        template(v-if="viewedUser.address && viewedUser.city")
                            | {{ viewedUser.city }}, {{ viewedUser.address }}
                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
                    .col-xs-12.col-md-6.contacts__item
                        .contacts__item-header E-mail:
                        template(v-if="showContactInfo && viewedUser.email") {{ viewedUser.email }}
                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
                    .col-xs-12.col-md-6.contacts__item(v-if="isMainContactInSomeSchool" )
                        .contacts__item-header {{ $i18n.t('profiles.profiles_profile_referralCode') }}
                        template(v-if="viewedUser.referralCode") {{ viewedUser.referralCode }}
                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
            .info__item(v-if="viewedUser.school || (viewedUser.schools && viewedUser.schools.length)")
                .info__item-header
                    |  {{ $i18n.tc('profiles.profiles_user_school', 1) }}
                divider(:margin="'25px auto 0'" :not-show-last-child="true")
                .schools
                    template(v-for="school in viewedUser.schools")
                        .row
                            .col-xs-12.col-md-6
                                .school
                                    svg-icon.school__icon(name="university", size="large")
                                    .school__info
                                        .school__name(
                                            :class="{ 'school__name_without-decorations': user.type === 'student' }"
                                            @click="goToSchoolProfile(school.id)"
                                        )
                                            | {{ school.name }}
                                        .school__address
                                            template(v-if="school.mainLocation")
                                                | {{ school.mainLocation.city + ','}}
                                                br
                                                | {{ school.mainLocation.address }}
                                            template(v-else) {{ $i18n.t('profiles.profiles_user_addressNoSpecified') }}
                            .col-xs-12.col-md-6
                                .grades(
                                    v-if="viewedUser.type === 'student' || viewedUser.type === 'teacher'"
                                    v-for="grade in userSchoolGrades(school.id)"
                                )
                                    .grade
                                        svg-icon.grade__icon(name="list-inverse", size="large")
                                        .grade__info
                                            router-link.grade__name(:to="{name: 'grade:profile', params: {id: grade.id}}")
                                                | {{ grade.name }}
                                            .grade__amount-of-students
                                                | {{ getAmountOfStudents(grade) }}
                        divider(:margin="'30px auto 0'" :not-show-last-child="true")
            template(v-if="viewedUser.type === 'student' || viewedUser.type === 'teacher'")
                .info__item
                    .info__item-header
                        | {{ $i18n.t('profiles.profiles_user_courses') }}
                    divider(:margin="'25px auto 0'" :not-show-last-child="true")
                    .row.courses
                        .col-xs-12.col-md-6(v-for="course in sortedCourses")
                            .course
                                svg-icon.course__icon(name="book", size="large")
                                .course__info
                                    router-link.course__name(
                                        v-if="user.type !== 'student' && user.type !== 'olympiad-student'"
                                        :to="{name: 'course:profile', params: {id: course.id}}"
                                    )
                                        | {{ course.name }}
                                    .course__name(v-else)
                                        | {{ course.name }}
                .info__item(v-if="viewedUser.type === 'student'")
                    .info__item-header
                        |  {{ $i18n.t('profiles.profiles_user_teachers') }}
                    divider(:margin="'25px auto 0'" :not-show-last-child="true")
                    .teachers(v-if="teachers && teachers.length > 0")
                        .row
                            .col-xs-12.col-md-6.teacher(v-for="teacher in teachers")
                                small-user-preview(:displayed-user="teacher")
                    .teachers__empty(v-else)
                        | {{ $i18n.t('profiles.profiles_user_teachersNoSpecified') }}
                .info__item
                    .info__item-header
                        |  {{ $i18n.t('profiles.profiles_user_closestClasses') }}
                    divider(:margin="'25px auto 0'" :not-show-last-child="true")
                    .lessons(v-if="nearestClasses && nearestClasses.length > 0")
                        template(v-for="lesson in nearestClasses")
                            .lesson
                                .lesson__info
                                    .lesson__course
                                        | {{ lesson.course.name }}
                                    .lesson__date
                                        | {{ lesson.date | moment('DD.MM.YYYY') }}
                                .school.lesson__school
                                    svg-icon.school__icon(name="university", size="large")
                                    .school__info
                                        router-link.school__name(
                                            :to="{name: 'school:profile', params: {id: lesson.grade.schoolId}}"
                                        )
                                            | {{ findSchoolById(lesson.grade.schoolId).name }}
                                .grade.lesson__grade
                                    svg-icon.grade__icon(name="list-inverse", size="large")
                                    .grade__info
                                        router-link.grade__name(:to="{name: 'grade:profile', params: {id: lesson.grade.id}}")
                                            | {{ lesson.grade.name }}
                            divider(:margin="'25px auto 0'" :not-show-last-child="true")
                    .lessons__empty(v-else)
                        | {{ $i18n.t('profiles.profiles_user_noClasses') }}
                template(v-if="viewedUser.type === 'student' && user.type !== 'student'")
                    .info__item
                        .info__item-header(@click="showHomeworks = !showHomeworks")
                            | {{ $i18n.t('profiles.profiles_user_homework') }}
                            svg-icon.angle__icon(
                                name="angle", height="9px", width="14px",
                                :class="{'angle__icon--inverse': !showHomeworks}"
                            )
                        divider(:margin="'25px auto 0'" :not-show-last-child="true")
                        template(v-if="showHomeworks")
                            template(v-if="!areHomeworksLoading")
                                .homeworks(v-if="uncompletedHomeworks && uncompletedHomeworks.length > 0")
                                    template(v-for="(homework, index) in uncompletedHomeworks")
                                        homework-preview(
                                            :homework="homework"
                                            :user="user"
                                            :viewed-user-id="viewedUser.id"
                                            :homeworkIndex="index"
                                            @statUpdated="updateStat"
                                            @homeworkUpdated="updateHomework"
                                        )
                                        divider(:margin="'30px auto 0'" :not-show-last-child="true")
                                .homeworks__empty(v-else)
                                    | {{ $i18n.t('profiles.profiles_user_noUnfinishedHomework') }}
                            cs-loader(v-else)
            template(v-if="viewedUser.type === 'student' && viewedUser.parents")
                .info__item
                    .info__item-header
                        | {{ $i18n.t('profiles.profiles_user_parents') }}
                    divider(:margin="'25px auto 0'" :not-show-last-child="true")
                    .row.parents
                        .col-xs-12.col-md-6.parent(v-for="parent in viewedUser.parents")
                            .parent__info
                                template(v-if="parent.firstName || parent.lastName")
                                    .parent__name
                                        | {{ parent.firstName }} {{ parent.lastName }}
                                    .parent__item.parent__phone
                                        .parent__item-header {{ $i18n.t('profiles.profiles_profile_phone') }}:
                                        template(v-if="parent.phone") {{ parent.phone }}
                                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
                                    .parent__item
                                        .parent__item-header E-mail:
                                        template(v-if="parent.email") {{ parent.email }}
                                        template(v-else) {{ $i18n.t('profiles.profiles_user_notSpecified') }}
                                template(v-else)
                                    .parent__name
                                        | {{ $i18n.t('profiles.profiles_user_parentsNoSpecified') }}
            .info__item(v-if="user.isSuperadmin && viewedUser.userAgent")
                .info__item-header
                    | {{ $i18n.t('profiles.profiles_user_technicalInfo') }}
                divider(:margin="'25px auto 0'" :not-show-last-child="true")
                .technical-information
                    strong User-Agent:&nbsp;
                    | {{ viewedUser.userAgent }}
        create-message-modal(
            v-if='showMessageModal',
            @close="switchModal('message')",
            :user='viewedUser',
            @send='sendMessage'
        )
        miles-modal(
            v-if='showMilesModal',
            @close="switchModal('miles')"
            @miles="user.type !== 'teacher' && (viewedUser.miles += arguments[0])",
            :user='viewedUser'
        )
        detective-points-modal(
            v-if='showDetectivePointsModal',
            @close="switchModal('detective-points')"
            @detectivepoints="user.type !== 'teacher' && (viewedUser.detectivePoints += arguments[0])",
            :user='viewedUser'
        )
        points-modal(
            v-if='showPointsModal',
            @close="switchModal('points')"
            @points='addPointsToUser',
            :user='viewedUser',
            :access='selectedAccess'
        )
        cs-modal(v-if="priceModal.show" is-blur @close="closePriceModal")
            .price-modal-text(
                v-html="$i18n.t('user.user_form_withdrawal_of_money', { payment: '<b>' + priceModal.price + ' ' + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', priceModal.price) + '</b>' })"
            )
            .price-modal-buttons
                cs-button(color="orange" @click="closePriceModal")
                    | {{ $i18n.t('user.user_form_cancel') }}
                cs-button(@click="restoreUser")
                    | {{ $i18n.t('user.user_form_confirm') }}
    cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    import UserApi from '../../api/user/user';
    import TimetableApi from '../../api/user/timetable';
    import HomeWorkApi from '../../api/homework/homework';

    import courseAccesses from '../../utils/user/courseAccesses';
    import authentication from '../../utils/user/authentication';
    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';
    import RestoreUserMixin from '../../utils/user/RestoreUserMixin';
    import sendMessageMixin from '../../utils/communication/sendMessageMixin';
    import TimetableMixin from '../../utils/user/timetable';

    import HomeworkPreview from './user-elements/HomeworkPreview.vue';
    import ProfilePreview from './ProfilePreview.vue';
    import SmallUserPreview from './default-elements/SmallUserPreview.vue';

    import CreateMessageModal from '../../modals/CreateMessageModal.vue';
    import MilesModal from '../../modals/MilesModal.vue';
    import DetectivePointsModal from '../../modals/DetectivePointsModal.vue';
    import PointsModal from '../../modals/PointsModal.vue';

    import getBase64FromUrl from '@/utils/getBase64FromUrl';
    import Cookies from 'js-cookie';
    import { TEACHER_TOKEN } from '../../config/cookies';

    import _ from 'lodash';

    export default {
        components: {
            SmallUserPreview,
            ProfilePreview,
            HomeworkPreview,
            CreateMessageModal,
            MilesModal,
            DetectivePointsModal,
            PointsModal,
        },
        props: {
            id: {
                type: [String, Number],
                default: null,
            },
        },
        mixins: [courseAccesses, authentication, BillingBlockMixin, RestoreUserMixin, TimetableMixin, sendMessageMixin, getBase64FromUrl],
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isMyProfile() {
                return this.user.id === this.viewedUser.id;
            },
            showContactInfo() {
                return !(
                    (this.user.type === 'teacher' && this.viewedUser && this.viewedUser.type === 'student') ||
                    (Cookies.get(TEACHER_TOKEN) && this.user.type === 'student')
                );
            },
            isButtonsAvailable() {
                return (
                    this.user &&
                    (this.user.isSuperadmin ||
                        this.user.isManagerOrSupport ||
                        this.viewedUser.id === this.user.id ||
                        (this.user.type !== 'student' &&
                            this.user.type !== 'olympiad-student' &&
                            (this.viewedUser.type === 'student' || this.viewedUser.type !== 'olympiad-student') &&
                            this.user.schoolsIds.some(id => this.viewedUser.schoolsIds.includes(id)))) &&
                    !(this.viewedUser.type === 'teacher' && this.user.type === 'teacher')
                );
            },
            canEditProfile() {
                return !(
                    this.user.type === 'teacher' &&
                    (this.viewedUser.type === 'student' || this.viewedUser.type === 'olympiads-student')
                );
            },
            canAuthInProfile() {
                return (
                    ((this.user.isSuperadmin && !this.viewedUser.isSuperadmin) ||
                        (this.user.isManagerOrSupport && !this.viewedUser.isManagerOrSupport) ||
                        (this.user.type === 'teacher' &&
                            (this.viewedUser.type === 'student' || this.viewedUser.type === 'olympiads-student'))) &&
                    this.viewedUser.status === 'active'
                );
            },
            sortedCourses() {
                if (this.viewedUser.type === 'teacher') {
                    return _.uniqBy(this.viewedUser.courses, 'id');
                }
                if (!this.viewedUser.grades.length) {
                    return [];
                }
                let sortedCourses = [];
                this.viewedUser.grades.forEach(grade => {
                    sortedCourses.push(grade.course);
                });
                return sortedCourses;
            },
            statusString() {
                return this.$i18n.t('profiles.profiles_profile_status' + _.capitalize(this.viewedUser.status));
            },
            averageProgress() {
                if (this.viewedUser) {
                    const progress = this.viewedUser.averageProgress;
                    return progress && progress.average ? Math.round(progress.average) + '%' : '—';
                }
            },
            arePointsAllowed() {
                return (
                    this.viewedUser.type === 'student' &&
                    this.viewedUser.status === 'active' &&
                    (this.$pointsSystem || this.$isMapAvailable || this.$isDetectiveAvailable)
                );
            },
            teachers() {
                return this.viewedUser && this.viewedUser.type === 'student'
                    ? _.uniqBy(_.flatten(_.map(this.viewedUser.grades, 'teachers')), 'id')
                    : [];
            },
            isMainContactInSomeSchool() {
                return this.viewedUser?.schools?.some(school => school.mainContactId === this.viewedUser.id);
            },
        },
        mounted() {
            this.fetchData();
        },
        beforeDestroy() {
            this.changeUserColors(this.user);
        },
        watch: {
            id() {
                this.fetchData();
            },
            viewedUser(user) {
                if (user && (user.type === 'student' || user.type === 'teacher')) {
                    this.getTimetable();
                    if (!this.uncompletedHomeworks) {
                        this.loadHomeworks();
                    }
                }
                this.changeUserColors(user);
            },
        },
        data() {
            return {
                isLoading: false,

                viewedUser: null,

                showHomeworks: true,
                uncompletedHomeworks: null,
                areHomeworksLoading: false,

                showMessageModal: false,
                showMilesModal: false,
                showDetectivePointsModal: false,
                showPointsModal: false,

                selectedAccess: '',
                errorStatus: null,

                priceModal: {
                    show: false,
                    price: 0,
                },
            };
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                UserApi.show(this.id)
                    .then(data => {
                        this.viewedUser = data;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        this.errorStatus = err.status;
                        this.isLoading = false;
                    });
            },
            async checkRestorePrice() {
                if (!this.isRestoreUserAllowed()) {
                    return;
                }
                if (this.viewedUser.type === 'teacher' || this.viewedUser.type === 'student') {
                    const price = await UserApi.getPriceForActivate(this.viewedUser.id);
                    this.priceModal.show = true;
                    this.priceModal.price = price;
                } else {
                    this.restoreUser();
                }
            },
            restoreUser() {
                if (!this.isRestoreUserAllowed()) {
                    return;
                }
                this.closePriceModal();
                if (this.viewedUser.type === 'admin' || this.viewedUser.school.status === 'active') {
                    UserApi.update(this.viewedUser.id, { status: 'active', school: this.viewedUser.school }).then(
                        () => {
                            this.viewedUser.status = 'active';
                        }
                    );
                } else {
                    this.$toasted.error(this.$root.$t('errors.school_archived_cant_restore_user'));
                }
            },
            archiveUser() {
                if (this.viewedUser.type === 'admin' || this.viewedUser.school.status === 'active') {
                    UserApi.update(this.viewedUser.id, { status: 'archived', school: this.viewedUser.school }).then(
                        () => {
                            this.viewedUser.status = 'archived';
                        }
                    );
                }
            },
            getAmountOfStudents(grade) {
                const amountOfStudents = grade.students.filter(student => student.status === 'active').length;
                return (
                    amountOfStudents +
                    ' ' +
                    this.$i18n.tc('profiles.profiles_user_studentsDeclension', amountOfStudents)
                );
            },
            userSchoolGrades(schoolId) {
                return this.viewedUser.grades.filter(grade => grade.schoolId === schoolId);
            },
            findSchoolById(schoolId) {
                return this.viewedUser.schools.find(school => school.id === schoolId);
            },
            getTimetable() {
                TimetableApi.list({ userId: this.id }).then(data => {
                    this.events = _.toArray(data);
                });
            },
            changeUserColors(user) {
                const root = document.documentElement;
                const userMainColor = user?.sex === 'female' ? 'hsl(15, 100%, 64%)' : 'hsl(212, 100%, 56%)';
                const userHelpColor = user?.sex === 'female' ? 'hsl(14, 91%, 58%)' : 'hsl(212, 100%, 48%)';
                root.style.setProperty('--user-main-color', userMainColor);
                root.style.setProperty('--user-help-color', userHelpColor);
            },
            routeObject(type, access = null) {
                let route;
                if (
                    this.$isDetectiveAvailable &&
                    this.courseAllowDetective &&
                    this.$isMapAvailable &&
                    this.courseAllowMap &&
                    ['miles', 'detective'].includes(type)
                ) {
                    route = { name: 'histories-progress', params: { type: type } };
                } else if (this.$isMapAvailable && this.courseAllowMap && type === 'miles') {
                    route = { name: 'miles-history:list' };
                } else if (this.$isDetectiveAvailable && this.courseAllowDetective && type === 'detective') {
                    route = { name: 'detective-points-history:list' };
                } else if (type === 'points') {
                    route = {
                        name: 'points-history',
                        params: { type: 'homework', pointsAccess: access },
                        query: {
                            pointsAccess: access,
                        },
                    };
                }

                const gradeIndex = this.viewedUser.grades.findIndex(grade => grade.access === access);

                Object.assign(route, {
                    query: {
                        schoolId: this.viewedUser.grades[0] && this.viewedUser.grades[0].schoolId,
                        gradeId: this.viewedUser.grades[gradeIndex] && this.viewedUser.grades[gradeIndex].id,
                        userId: this.viewedUser.id,
                    },
                });
                return route;
            },
            pointsForAccess(access) {
                switch (access) {
                    case 'mentalArithmetic':
                        return this.viewedUser.points - (
                            this.viewedUser.fastReadingPoints +
                            this.viewedUser.onlineSchoolPoints +
                            this.viewedUser.mathMagicPoints +
                            this.viewedUser.memoryDevelopmentPoints +
                            this.viewedUser.multiplicationPoints +
                            this.viewedUser.readingEnPoints +
                            this.viewedUser.russianLanguagePoints
                        );
                    case 'fastReading':
                        return this.viewedUser.fastReadingPoints;
                    case 'onlineSchool':
                        return this.viewedUser.onlineSchoolPoints;
                    case 'mathMagic':
                        return this.viewedUser.mathMagicPoints;
                    case 'memoryDevelopment':
                        return this.viewedUser.memoryDevelopmentPoints;
                    case 'multiplication':
                        return this.viewedUser.multiplicationPoints;
                    case 'readingEn':
                        return this.viewedUser.readingEnPoints;
                    case 'russianLanguage':
                        return this.viewedUser.russianLanguagePoints;
                }
            },
            loadHomeworks() {
                this.areHomeworksLoading = true;
                let request = {
                    userId: this.viewedUser.id,
                };
                HomeWorkApi.uncompletedHomework(request)
                    .then(data => {
                        this.uncompletedHomeworks = _.orderBy(data.homeworks, 'date') || [];
                        this.uncompletedHomeworks.forEach(homework => {
                            homework.exercises.forEach(exercise => {
                                if (exercise.slug === 'Puzzle') {
                                    this.replacePuzzleImageOnBase64(exercise);
                                }
                            });
                        });
                        this.areHomeworksLoading = false;
                    })
                    .catch(err => {
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                        this.areHomeworksLoading = false;
                    });
            },
            updateHomework(homeworkIndex) {
                let homework = this.uncompletedHomeworks[homeworkIndex];
                homework.pivot.isCompleted = true;
                homework.exercises.forEach(exercise => {
                    if (!exercise.allStats.length) {
                        exercise.allStats.push({
                            userId: this.viewedUser.id,
                            isCompleted: true,
                        });
                    } else {
                        exercise.allStats[0].isCompleted = true;
                    }
                });
            },
            updateStat(newStat, exerciseIndex, homeworkIndex) {
                let homework = this.uncompletedHomeworks[homeworkIndex];
                let stats = homework.exercises[exerciseIndex].allStats;
                stats[0] ? (stats[0] = newStat) : stats.push(newStat);
                let isCompleted = homework.exercises.every(exercise => {
                    let stat = exercise.allStats[0];
                    return stat ? stat.isCompleted : false;
                });
                if (isCompleted) {
                    homework.pivot.isCompleted = true;
                }
            },
            switchModal(name, access = null) {
                if (name === 'points' && !this.showPointsModal) {
                    this.selectedAccess = access;
                }
                const showProperty = _.camelCase('show-' + name + '-modal');
                this[showProperty] = !this[showProperty];
            },
            addPointsToUser(points) {
                if (this.user.type !== 'teacher') {
                    switch (this.selectedAccess) {
                        case 'mentalArithmetic':
                            this.viewedUser.points += points;
                            break;
                        case 'fastReading':
                            this.viewedUser.fastReadingPoints += points;
                            break;
                        case 'mathMagic':
                            this.viewedUser.mathMagicPoints += points;
                            break;
                        case 'memoryDevelopment':
                            this.viewedUser.memoryDevelopmentPoints += points;
                            break;
                        case 'readingEn':
                            this.viewedUser.readingEnPoints += points;
                            break;
                        case 'onlineSchool':
                            this.viewedUser.onlineSchoolPoints += points;
                            break;
                        case 'multiplication':
                            this.viewedUser.multiplicationPoints += points;
                            break;
                        case 'russianLanguage':
                            this.viewedUser.russianLanguagePoints += points;
                            break;
                    }
                }
            },
            async replacePuzzleImageOnBase64(exercise) {
                exercise.parameters.default.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(exercise.parameters.default.imageSrc)
                );
            },
            goToSchoolProfile(schoolId) {
                if (this.user.type === 'student') {
                    return;
                }

                this.$router.push({ name: 'school:profile', params: { id: schoolId } });
            },
            closePriceModal() {
                this.priceModal.show = false;
                this.priceModal.price = 0;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .profile__avatar {
        border-radius: 50%;
        max-height: none;
        height: 140px;
        width: 140px;
        border: 10px solid rgba($hsl-color-gray-100, 0.2);
    }

    .profile__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        color: $x-color-white;
        margin: 20px 0 30px;
        text-align: center;
    }

    .profile__items {
        width: 100%;
    }

    .profile__box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;

        max-width: 240px;
        @include media($md) {
            max-width: 100%;
        }
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .profile__send-message-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .profile__send-message {
        max-width: 240px;
    }

    .profile__item {
        box-sizing: border-box;
        padding: 0;
        color: $x-color-white;
        display: flex;
        font-size: 18px;
        line-height: 24px;
        margin-top: 34px;
    }

    .profile__item--size {
        width: 100%;
        @include media($md) {
            width: 50%;
            &:nth-child(odd) {
                padding-right: 20px;
            }
        }
        @include media($xlg) {
            width: 100%;
        }
    }

    .profile__icon {
        padding-top: 5px;
        margin-right: 10px;
    }

    .profile__icon--small {
        margin-right: 16px;
    }

    .profile__info {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .info__header {
        font-weight: 500;
    }

    .info__body {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        width: 100%;
    }

    .profile__link {
        font-size: 18px;
        line-height: 26px;
        color: $x-color-white;
        text-decoration-line: underline;
    }

    .info__buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 20px 0;
        @include media($lg) {
            margin: 0 0 20px;
            flex-direction: row;
            justify-content: flex-end;
        }
    }

    .info__button {
        margin-bottom: 10px;
        @include media($lg) {
            margin-left: 10px;
        }
    }

    .info__item {
        padding: 30px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        margin-bottom: 0;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .info__item-header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .contacts__item {
        margin-top: 25px;
        font-size: 16px;
        line-height: 24px;
    }

    .contacts__item-header {
        font-weight: 500;
    }

    .school,
    .grade,
    .course,
    .parent {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
        &:nth-child(odd) {
            padding-right: 20px;
        }
    }

    .teacher {
        display: flex;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .school__icon,
    .grade__icon,
    .course__icon {
        color: $hsl-color-green-58;
        margin-right: 15px;
    }

    .school__info,
    .grade__info,
    .course__info,
    .parent__info {
        font-size: 16px;
        line-height: 24px;
        color: $x-color-black;
    }

    .school__name,
    .grade__name,
    .course__name {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        cursor: pointer;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school__name_without-decorations {
        color: #333333;
        text-decoration: none;
        pointer-events: none;
    }

    .lessons__empty,
    .homeworks__empty,
    .teachers__empty {
        margin-top: 30px;
    }

    .lesson {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-top: 30px;
        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .lesson__info {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }

    .lesson__school,
    .lesson__grade {
        margin-top: 12px;
    }

    .technical-information {
        margin-top: 25px;
    }

    .parent__name {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
    }

    .parent__item {
        margin-top: 25px;
    }

    .parent__item-header {
        font-weight: 500;
    }

    .angle__icon {
        color: $hsl-color-blue-56;
    }

    .angle__icon--inverse {
        transform: rotate(0.5turn);
    }

    .price-modal-text {
        margin-top: 20px;
    }

    .price-modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cs-button {
            padding: 15px 20px;
            @include media($md) {
                padding: 15px 30px;
            }
        }
    }
</style>
